import { liveRooms } from "@/mocks/baogua";

export default function LiveBar() {
  const doubled = [...liveRooms, ...liveRooms];
  return (
    <section id="live" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-live-fill"></i> 实时开播
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              正在直播的<span className="font-display text-primary-500">滚动瓜场</span>
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              每个频道都是一个实时更新的吃瓜直播间，进度条与弹幕同步推进，点开就能加入围观。
            </p>
          </div>
          <button onClick={() => document.getElementById("deep")?.scrollIntoView({ behavior: "smooth" })}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300/70 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition">
            查看全部直播间 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {liveRooms.map((r) => (
            <article key={r.id} className="group flex flex-col gap-3 rounded-2xl bg-background-100 p-4 transition hover:bg-background-200/60 md:p-5">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 rounded-full bg-background-50 px-2.5 py-1 text-xs font-medium text-foreground-700">
                  <i className="ri-tv-2-fill text-accent-500"></i> {r.category}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i> {r.viewers}
                </span>
              </div>
              <h3 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">{r.title}</h3>
              <div className="mt-auto flex items-center justify-between border-t border-background-200/70 pt-3">
                <span className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-secondary-300 to-secondary-500 text-xs font-bold text-background-50">
                    {r.host.slice(0, 1)}
                  </span>
                  {r.host}
                </span>
                <button onClick={() => {}} aria-label="进入直播"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1.5 text-xs font-semibold text-background-50 hover:bg-primary-600 transition">
                  <i className="ri-live-line"></i> 进直播间
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}